const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./views/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

export const AppViews = {
  // Customers
  // index: asyncComponentFactory('Home'),
  // article: asyncComponentFactory('Article'),
  cart: asyncComponentFactory('Cart'),
  product: asyncComponentFactory('Product'),
  // collection: asyncComponentFactory('Collection'),
  // search: asyncComponentFactory('Collection'),
  // ['list-collections']: asyncComponentFactory('Collection'),
  // order: asyncComponentFactory('Customers/Order'),
  addresses: asyncComponentFactory('Customers/Addresses'),
  // account: asyncComponentFactory('Customers/Account'),
  login: asyncComponentFactory('Customers/Login'),
  // contact: asyncComponentFactory('pages/Contact'),  
  'pro-program': asyncComponentFactory('pages/ProProgram'),
  page: asyncComponentFactory('pages/Page'),
};
